import { Suspense, lazy } from 'react';
import type { RouteObject } from 'react-router';
import { Outlet } from 'react-router-dom';
import { Loader } from 'src/components/placeholders/loader';
import { UnderConstruction } from 'src/components/under-construction';
import { AuthGuard } from 'src/guards/auth-guard';
import { Layout } from 'src/layouts/default';

// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const PostCreatePage = lazy(() => import('src/pages/admin/post/create'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const PostEditPage = lazy(() => import('src/pages/admin/post/edit'));

// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const ContentDraftsPage = lazy(() => import('src/pages/admin/content/drafts'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const ContentPlannedPage = lazy(() => import('src/pages/admin/content/planned'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const ContentPublishedPage = lazy(() => import('src/pages/admin/content/published'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const ContentResultsPage = lazy(() => import('src/pages/admin/content/results'));

// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const NewsletterDraftsPage = lazy(() => import('src/pages/admin/newsletter/drafts'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const NewsletterPlannedPage = lazy(() => import('src/pages/admin/newsletter/planned'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const NewsletterPublishedPage = lazy(() => import('src/pages/admin/newsletter/published'));

// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const OccasionDraftsPage = lazy(() => import('src/pages/admin/occasion/drafts'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const OccasionPlannedPage = lazy(() => import('src/pages/admin/occasion/planned'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const OccasionPublishedPage = lazy(() => import('src/pages/admin/occasion/published'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const OccasionResultsPage = lazy(() => import('src/pages/admin/occasion/results'));

// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const ManagementPage = lazy(() => import('src/pages/admin/management'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const GroupPage = lazy(() => import('src/pages/admin/management/group'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const CompanyPage = lazy(() => import('src/pages/admin/management/company'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const MemberPage = lazy(() => import('src/pages/admin/management/member'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const ListPage = lazy(() => import('src/pages/admin/management/list'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const SurveyTemplatePage = lazy(() => import('src/pages/admin/management/survey-template'));

// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const SettingsPage = lazy(() => import('src/pages/admin/settings'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const SignaturePage = lazy(() => import('src/pages/admin/settings/signature'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const EmailTemplatePage = lazy(() => import('src/pages/admin/settings/email-template'));

export const adminRoutes: RouteObject[] = [
  {
    path: 'content',
    element: (
      <AuthGuard>
        <Layout>
          <Suspense fallback={<Loader />}>
            <Outlet />
          </Suspense>
        </Layout>
      </AuthGuard>
    ),
    children: [
      {
        path: 'drafts',
        element: <ContentDraftsPage />
      },
      {
        path: 'planned',
        element: <ContentPlannedPage />
      },
      {
        path: 'published',
        element: <ContentPublishedPage />
      },
      {
        path: 'create',
        element: <PostCreatePage />
      },
      {
        path: 'edit/:mode/:id/:step',
        element: <PostEditPage />
      },
      {
        path: 'results/:id',
        element: <ContentResultsPage />
      }
    ]
  },
  {
    path: 'newsletter',
    element: (
      <AuthGuard>
        <Layout>
          <Suspense fallback={<Loader />}>
            <Outlet />
          </Suspense>
        </Layout>
      </AuthGuard>
    ),
    children: [
      {
        path: 'drafts',
        element: <NewsletterDraftsPage />
      },
      {
        path: 'planned',
        element: <NewsletterPlannedPage />
      },
      {
        path: 'create',
        element: <PostCreatePage />
      },
      {
        path: 'edit/:mode/:id/:step',
        element: <PostEditPage />
      },
      {
        path: 'published',
        element: <NewsletterPublishedPage />
      },
      {
        path: 'results/:id',
        element: <UnderConstruction />
      }
    ]
  },
  {
    path: 'occasion',
    element: (
      <AuthGuard>
        <Layout>
          <Suspense fallback={<Loader />}>
            <Outlet />
          </Suspense>
        </Layout>
      </AuthGuard>
    ),
    children: [
      {
        path: 'drafts',
        element: <UnderConstruction />
      },
      {
        path: 'planned',
        element: <UnderConstruction />
      },
      {
        path: 'published',
        element: <OccasionPublishedPage />
      },
      {
        path: 'create',
        element: <UnderConstruction />
      },
      {
        path: 'edit/:id/:step',
        element: <UnderConstruction />
      },
      {
        path: 'results/:id',
        element: <OccasionResultsPage />
      }
    ]
  },
  {
    path: 'admin',
    element: (
      <AuthGuard>
        <Layout>
          <Suspense fallback={<Loader />}>
            <Outlet />
          </Suspense>
        </Layout>
      </AuthGuard>
    ),
    children: [
      {
        path: 'manage',
        children: [
          {
            index: true,
            element: <ManagementPage />
          },
          {
            path: 'group/:groupId',
            element: <GroupPage />
          },
          {
            path: 'company/:companyId',
            element: <CompanyPage />
          },
          {
            path: 'member/:memberId',
            element: <MemberPage />
          },
          {
            path: 'list/:listId',
            element: <ListPage />
          },
          {
            path: 'survey-template/:surveyId',
            element: <SurveyTemplatePage />
          }
        ]
      },
      {
        path: 'settings',
        children: [
          {
            index: true,
            element: <SettingsPage />
          },
          {
            path: 'signature/:id',
            element: <SignaturePage />
          },
          {
            path: 'template/:id',
            element: <EmailTemplatePage />
          }
        ]
      }
    ]
  }
];
